import { render, staticRenderFns } from "./cost_show.vue?vue&type=template&id=62316d60&"
import script from "./cost_show.vue?vue&type=script&lang=js&"
export * from "./cost_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports